import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

export const AppAdsBasePlacement = ({
  classes,
  children,
}) => (
  <div className={classnames('ad-placement-card-preview', classes.placementPreview, 'app-ads-preview')}>
    <div className={classnames(classes.placementCard, 'ad-placement-card-mobile-layout')}>
      <div className={classnames(classes.phoneInnerContent)}>
        {children}
      </div>
    </div>
  </div>
);

AppAdsBasePlacement.propTypes = {
  classes: PropTypes.shape({
    placementPreview: PropTypes.string,
    placementCard: PropTypes.string,
    phoneInnerContent: PropTypes.string,
  }),
  children: PropTypes.node,
};

AppAdsBasePlacement.defaultProps = {
  classes: {},
  children: null,
};
